// React
import React from "react";
// Recoil
import { useRecoilValue, useSetRecoilState } from "recoil";
import {
  activeTable,
  isMenuView,
  tableOrderList,
  popupState,
} from "../../atom/pos";

//Components
import PosSideMenu from "./PosSideMenu";
import { PosPopupRes } from "./PosPopup";

function PosContent() {
  // 포스 메인 테이블 전체 화면

  // Recoil State
  const isMenu = useRecoilValue(isMenuView);
  const popUp = useRecoilValue(popupState);

  return (
    <>
      <div className="content-wrap">
        {isMenu && <PosSideMenu />}
        <PosContentMenu />
        <PosContentList />
      </div>
      {popUp === "res" ? <PosPopupRes /> : null}
    </>
  );
}

function PosContentMenu() {
  // 포스 메인 테이블 상단 리스트 컴포넌트
  const menu = [
    "기본 보기",
    "주문내역",
    "이동",
    "단체",
    "예약",
    "재출력",
    "돈통",
  ];

  return (
    <div className="content-menu-warp">
      <div className="box navy" style={{ marginRight: "1%" }}>
        거래내역
      </div>
      {menu.map((v, i) => (
        <div key={i} className="box blue">
          {v}
        </div>
      ))}
      <div className="box whitebg" style={{ marginLeft: "1%" }}>
        배달
      </div>
      <div className="box whitebg" style={{ width: 52 }}>
        <img
          className="icon"
          src={"/assets/images/pos/arrow_left.svg"}
          alt="arrow-left"
        />
      </div>
      <div className="box active">1층</div>
      <div className="box whitebg">2층</div>
      <div className="box whitebg" style={{ width: 52 }}>
        <img
          className="icon"
          src={"/assets/images/pos/arrow_right.svg"}
          alt="arrow-right"
        />
      </div>
    </div>
  );
}

type MenuTypes = { price: number; ea: number; name: string };
function PosContentList() {
  // 포스 메인 테이블 리스트 컴포넌트

  // Recoil State
  const setTable = useSetRecoilState(activeTable);
  const tables = useRecoilValue(tableOrderList);

  const calcPrice = (data: MenuTypes[]) => {
    let amt = 0 as number;
    data.reduce((acc, cur) => {
      amt = acc + cur.price * cur.ea;
      return amt;
    }, amt);
    return amt;
  };

  return (
    <div
      className="content-list-warp"
      style={{ backgroundImage: "url(/assets/images/pos/pos_table_bg.jpg)" }}
    >
      {tables.map((v, i) =>
        v.time === "" ? (
          <div
            className="table-wrap"
            key={i}
            style={{ backgroundImage: "url(/assets/images/pos/plus.svg)" }}
            onClick={() => {
              setTable(v.num);
            }}
          >
            <div className="bg">
              <div className="table-row">
                <span className="table-num">
                  {v.num > 9 ? v.num : "0" + v.num}
                </span>
              </div>
            </div>
          </div>
        ) : (
          <div
            className="table-wrap-active"
            key={i}
            onClick={() => {
              setTable(v.num);
            }}
          >
            <div className="active-bg">
              <div className="table-row">
                <span className="table-num-active">
                  {v.num > 9 ? v.num : "0" + v.num}
                </span>
                <span className="table-time">{v.time}</span>
              </div>
              <div className="table-menu-wrap">
                {v.menu.slice(0, 4).map((v, i) => {
                  return (
                    <div key={i} className="table-row">
                      <span className="table-menu">{v.name}</span>
                      <span className="table-time">{v.ea}</span>
                    </div>
                  );
                })}
              </div>
            </div>
            <div className="table-price">
              {calcPrice(v.menu).toLocaleString()}(후결제)
            </div>
          </div>
        )
      )}
    </div>
  );
}

export default PosContent;
